<template>
  <div>
    <input
      ref="inputVertical"
      type="file"
      class="d-none"
      accept="video/*"
      @change="enviarArquivo"
    >
    <input
      ref="inputHorizontal"
      type="file"
      class="d-none"
      accept="video/*"
      @change="enviarArquivo"
    >
    
    <div id="tour-step-upload-btn">
      <el-button
        size="small"
        class="btnpersonalizado"
        type="danger"
        data-v-step="1"
        @click="openUploadModal"
      >
        <feather-icon
          icon="UploadCloudIcon"
          stroke="white"
        />
        Upload
      </el-button>
    </div>

    <!-- Modal de Upload -->
    <div
      v-if="uploadModalVisible"
      class="modal-overlay"
      @click="closeUploadModal"
    >
      <div
        class="modal-content"
        @click.stop
      >
        <h2>Selecione os vídeos para upload</h2>
        <div class="upload-options">
          <div
            class="upload-option-card"
            :class="{ 'selected': selectedFiles.vertical }"
            @click="openFileDialog('vertical')"
          >
            <div class="upload-icon">
              <feather-icon
                icon="SmartphoneIcon"
                size="48"
                :stroke="selectedFiles.vertical ? '#67C23A' : '#409EFF'"
              />
            </div>
            <h3>Vídeo Vertical</h3>
            <p>Para vídeos no formato vertical (9:16) ideal para mobile</p>
            <div
              v-if="selectedFiles.vertical"
              class="selected-file"
            >
              <i class="el-icon-check" />
              {{ selectedFiles.vertical.name }}
            </div>
            <el-button
              :type="selectedFiles.vertical ? 'success' : 'primary'"
              size="small"
            >
              {{ selectedFiles.vertical ? 'Alterar Arquivo' : 'Selecionar Arquivo' }}
            </el-button>
          </div>

          <div
            class="upload-option-card"
            :class="{ 'selected': selectedFiles.horizontal }"
            @click="openFileDialog('horizontal')"
          >
            <div class="upload-icon">
              <feather-icon
                icon="MonitorIcon"
                size="48"
                :stroke="selectedFiles.horizontal ? '#67C23A' : '#409EFF'"
              />
            </div>
            <h3>Vídeo Horizontal</h3>
            <p>Para vídeos no formato horizontal (16:9) ideal para desktop</p>
            <div
              v-if="selectedFiles.horizontal"
              class="selected-file"
            >
              <i class="el-icon-check" />
              {{ selectedFiles.horizontal.name }}
            </div>
            <el-button
              :type="selectedFiles.horizontal ? 'success' : 'primary'"
              size="small"
            >
              {{ selectedFiles.horizontal ? 'Alterar Arquivo' : 'Selecionar Arquivo' }}
            </el-button>
          </div>
        </div>

        <div class="modal-footer">
          <el-button @click="closeUploadModal">
            Cancelar
          </el-button>
          <el-button
            type="primary"
            :disabled="selectedFilesCount === 0"
            @click="uploadSelectedFiles"
          >
            Fazer Upload ({{ selectedFilesCount }})
          </el-button>
        </div>
      </div>
    </div>

    <!-- Modal de Upload Original (comentado para teste)
    <el-dialog
      :visible.sync="uploadModalVisible"
      title="Selecione os vídeos para upload"
      width="600px"
      :before-close="closeUploadModal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="upload-options">
        <div
          class="upload-option-card"
          :class="{ 'selected': selectedFiles.vertical }"
          @click="openFileDialog('vertical')"
        >
          <div class="upload-icon">
            <feather-icon
              icon="SmartphoneIcon"
              size="48"
              :stroke="selectedFiles.vertical ? '#67C23A' : '#409EFF'"
            />
          </div>
          <h3>Vídeo Vertical</h3>
          <p>Para vídeos no formato vertical (9:16) ideal para mobile</p>
          <div
            v-if="selectedFiles.vertical"
            class="selected-file"
          >
            <i class="el-icon-check" />
            {{ selectedFiles.vertical.name }}
          </div>
          <el-button
            :type="selectedFiles.vertical ? 'success' : 'primary'"
            size="small"
          >
            {{ selectedFiles.vertical ? 'Alterar Arquivo' : 'Selecionar Arquivo' }}
          </el-button>
        </div>

        <div
          class="upload-option-card"
          :class="{ 'selected': selectedFiles.horizontal }"
          @click="openFileDialog('horizontal')"
        >
          <div class="upload-icon">
            <feather-icon
              icon="MonitorIcon"
              size="48"
              :stroke="selectedFiles.horizontal ? '#67C23A' : '#409EFF'"
            />
          </div>
          <h3>Vídeo Horizontal</h3>
          <p>Para vídeos no formato horizontal (16:9) ideal para desktop</p>
          <div
            v-if="selectedFiles.horizontal"
            class="selected-file"
          >
            <i class="el-icon-check" />
            {{ selectedFiles.horizontal.name }}
          </div>
          <el-button
            :type="selectedFiles.horizontal ? 'success' : 'primary'"
            size="small"
          >
            {{ selectedFiles.horizontal ? 'Alterar Arquivo' : 'Selecionar Arquivo' }}
          </el-button>
        </div>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeUploadModal">Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!hasSelectedFiles"
          @click="uploadSelectedFiles"
        >
          Fazer Upload ({{ selectedFilesCount }})
        </el-button>
      </span>
    </el-dialog>
    -->

  </div>

</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from 'vuex'
import { GetFrameVideoUrl } from '@/services/getFrameVideoUrl'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { UploadVideoService } from '@/services/uploadVideo'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'Upload',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      statusConversion: '',
      loading: false,
      loadingts: 20000,
      caminhoPasta: '',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      userData: JSON.parse(localStorage.getItem('userData')),
      folderData: JSON.parse(localStorage.getItem('folderData')),
      folderATUAL: {},
      form: {
        files: '',
      },
      uploadModalVisible: false,
      currentUploadType: null,
      selectedFiles: {
        vertical: null,
        horizontal: null,
      },
      file: '',
      notification: null,
      notificationStatus: null,
      uploadPercentage: 0,
      vsl: {
        vsl_name: 'De um nome ao video',
        vsl_description: 'Sem Descrição',
        vsl_tag: 'Sem tag',
        id_user: '5',
        id_folder: '0',

      },
      estilo: {
        id_vsl: '45',
        controls_bt_big_player: '1',
        controls_bt_small_player: '1',
        controls_progress_bar: '1',
        controls_video_time: '1',
        controls_video_vol: '1',
        controls_bt_screem: '1',
        controls_avan_10s: '1',
        controls_retro_10s: '1',
        controls_back_color: '#ff0000',
        controls_main_color: '#ff0000',
      },
      Autoplay: {
        autoplayer_text_color: '#f5f5f5',
        autoplayer_back_color: '#ad1414',
        autoplayer_top_text: 'Seu vídeo já começou',
        autoplayer_button_text: 'Clique para ouvir',
      },
      ProgressoInt: {
        bar_hight: 10,
        bar_cor: '#de1717',
      },
      Viewer: {
        viewer_message: 'Você já começou a assistir esse vídeo, o que deseja fazer? ',
        viewer_bt_restart: 'Recomeçar',
        viewer_bt_continue: 'Continuar assistindo',
        viewer_back_color: '#f60909',
        viewer_color_text: '#f1f2f2',
        id_vsl: 182,
      },
      thumb: {
        tumb_start: '',
        tumb_pause: '',
        tumb_end: '',
        tumb_ativo: 0,
        tumb_key_name: '',
      },
      vslTempoVideoSemFormat: '',
      errorMessage: null,
      vslTempoVideo: '',
      UrlVideos: '',
      Hashfolder: '',
      NameVideos: '',
      key_name: '',
      IdVsl: '',
      frameCurrentVsl: {},
    }
  },
  computed: {
    ...mapState('Folders', ['folderAtual']),
    hasSelectedFiles() {
      return this.selectedFiles.vertical || this.selectedFiles.horizontal
    },
    selectedFilesCount() {
      let count = 0
      if (this.selectedFiles.vertical) count += 1
      if (this.selectedFiles.horizontal) count += 1
      return count
    },
  },

  mounted() {
    this.listarFolders()
  },
  methods: {
    ...mapActions('Videos', ['listarVideos']),
    ...mapActions('Folders', ['listarFolders']),

    open() {
      this.notification = this.$notify({
        title: 'Arquivo(s)',
        dangerouslyUseHTMLString: true,
        message: `<div class="container">
 <strong>Fazendo upload <i>${this.uploadPercentage}%</i> </strong>
  <div class="progress">
    <div class="progress-bar" style="width:${this.uploadPercentage}%">${this.uploadPercentage}%</div>
  </div>
</div>`,
        position: 'bottom-right',
        duration: 0,
      })
    },
    close() {
      this.notification.close()
      this.notification = null
    },
    closeStatusConversao() {
      this.notificationStatus.close()
      this.notificationStatus = null
    },

    openUploadModal() {
      this.uploadModalVisible = true
      this.idfolderAtual()
    },

    closeUploadModal() {
      this.uploadModalVisible = false
      this.currentUploadType = null
      this.selectedFiles = {
        vertical: null,
        horizontal: null,
      }
    },

    openFileDialog(type) {
      if (!type) {
        // Comportamento antigo para compatibilidade
        this.$refs.inputVertical.value = null
        this.$refs.inputVertical.click()
        return
      }
      
      this.currentUploadType = type
      
      if (type === 'vertical') {
        this.$refs.inputVertical.value = null
        this.$refs.inputVertical.click()
      } else if (type === 'horizontal') {
        this.$refs.inputHorizontal.value = null
        this.$refs.inputHorizontal.click()
      }
    },

    async uploadSelectedFiles() {
      if (this.selectedFiles.vertical) {
        await this.uploadSingleFile(this.selectedFiles.vertical, 'vertical')
      }
      if (this.selectedFiles.horizontal) {
        await this.uploadSingleFile(this.selectedFiles.horizontal, 'horizontal')
      }
      
      this.closeUploadModal()
      
      this.$message({
        type: 'success',
        message: 'Todos os uploads foram concluídos com sucesso',
      })
    },

    clearFolder() {
      this.$store.commit('Folders/setfolderAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },
    async idfolderAtual() {
      this.folderATUAL = JSON.parse(localStorage.getItem('folderATUAL'))
    },

    async enviarArquivo(e) {
      const file = e.target.files[0]
      if (!file) return

      // Armazena o arquivo selecionado baseado no tipo atual
      if (this.currentUploadType) {
        this.selectedFiles[this.currentUploadType] = file
      } else {
        // Comportamento antigo - faz upload direto
        await this.uploadSingleFile(file, 'vertical')
      }
    },

    normalizeFileName(fileName) {
      // Remove acentos e caracteres especiais
      const normalized = fileName
        .normalize('NFD') // Decompõe caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
        .replace(/[^a-zA-Z0-9._-]/g, '_') // Substitui caracteres especiais por underscore
        .replace(/\s+/g, '_') // Substitui espaços por underscore
        .replace(/_+/g, '_') // Remove underscores duplicados
        .toLowerCase() // Converte para minúsculas
      return normalized
    },

    async uploadSingleFile(file, videoType) {
      this.loading = true

      if (this.folderATUAL === 0) {
        this.caminhoPasta = `${this.userData.user_file_key}UploadFolderVideos/`
      } else {
        this.caminhoPasta = this.folderATUAL.folder_key_name
        console.log('loadin', this.uploadPercentage)
      }

      const originalFileName = file.name
      const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'))
      const fileNameWithoutExtension = originalFileName.substring(0, originalFileName.lastIndexOf('.'))
      const normalizedFileName = this.normalizeFileName(fileNameWithoutExtension) + fileExtension

      // Cria um novo arquivo com o nome normalizado
      const normalizedFile = new File([file], normalizedFileName, { type: file.type })

      const formData = new FormData()

      formData.append('video', normalizedFile)
      formData.append('caminho', `${this.caminhoPasta}`)
      formData.append('videoType', videoType)
      
      this.open()
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/uploadVideos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            const Big = require('big.js') // importação da biblioteca
            const loaded = new Big(progressEvent.loaded)
            const total = new Big(progressEvent.total)
            this.uploadPercentage = parseInt(loaded.div(total).times(100))
          }.bind(this),

        })

        .then(async response => {
          this.vslTempoVideo = response.data.data.durationFormatted
          this.vslTempoVideoSemFormat = response.data.data.duration
          this.UrlVideos = response.data.data.fileUrl
          this.UrlVideosM3U8 = response.data.data.fileUrlm3u8
          this.NameVideos = response.data.data.fileNameOrigin
          this.key_name = response.data.data.caminhoFolder
          const paramsMidiaConvert = {
            key_vls: response.data.data.key_filename,
            key_folder: response.data.data.caminhoFolder,
            name_vsl: response.data.data.fileNameOrigin,

          }
          this.MidiaConvert(paramsMidiaConvert)

          if (response.data.data.status === 201) {
            this.frameCurrentVsl = {
              video_url: this.UrlVideos,
              caminho: response.data.data.caminhoFolder,
            }
            if (!this.videoGroupId) {
              this.videoGroupId = `${this.userData.id}_${Date.now()}` // Exemplo simples, pode usar uuid
            }
            const orientation = videoType === 'vertical' ? 'Vertical' : 'Horizontal'
            await fetch(`${this.VUE_APP_HOST_API_BACKEND}/vsl`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: `{"vsl_name":"${this.NameVideos}",
                "vsl_description":"${this.vsl.vsl_description}",
                "vsl_tag":"${this.vsl.vsl_tag}",
                "id_user":"${this.userData.id}",
                "id_folder":"${this.folderATUAL.id}",
                "vsl_bucket_address":"${this.UrlVideos}",
                "vsl_key_name":"${this.key_name}",
                "vsl_frame":"${this.UrlVideos}",
                "vsl_tempoVideo":"${this.vslTempoVideo}",
                "vsl_bucket_address_m3u8":"${this.UrlVideosM3U8}",
                "videoGroupId":"${this.videoGroupId}",
                "orientation":"${orientation}"
              }`,
            })
              .finally(() => {
                this.loading = false
                this.loadingts = 0
              })
              .then(response => response.json())
              .then(async response => {
                this.IdVsl = response.Id
                this.frameCurrentVsl.vsl_id = response.Id
                this.listarVideos()
                this.$message({
                  type: 'success',
                  message: 'Upload concluido com sucesso',
                })

                if (response.status === 201) {
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/control`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","controls_bt_big_player":"${this.estilo.controls_bt_big_player
                    }","controls_bt_small_player":"${this.estilo.controls_bt_small_player
                    }","controls_progress_bar":"${this.estilo.controls_progress_bar
                    }","controls_video_time":"${this.estilo.controls_video_time
                    }","controls_video_vol":"${this.estilo.controls_video_vol
                    }","controls_bt_screem":"${this.estilo.controls_bt_screem
                    }","controls_retro_10s":"${this.estilo.controls_retro_10s
                    }","controls_avan_10s":"${this.estilo.controls_avan_10s
                    }","controls_back_color":"${this.estilo.controls_back_color
                    }","controls_main_color":"${this.estilo.controls_main_color
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/atuvsl`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","ptime":"${this.vslTempoVideoSemFormat}","pvisitorId":"0"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/autoplayer`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","autoplayer_text_color":"${this.Autoplay.autoplayer_text_color
                    }","autoplayer_back_color":"${this.Autoplay.autoplayer_back_color
                    }","autoplayer_top_text":"${this.Autoplay.autoplayer_top_text
                    }","autoplayer_button_text":"${this.Autoplay.autoplayer_button_text
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/bar`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","bar_hight":"${this.ProgressoInt.bar_hight
                    }","bar_cor":"${this.ProgressoInt.bar_cor
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/viewer`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","viewer_message":"${this.Viewer.viewer_message
                    }","viewer_bt_restart":"${this.Viewer.viewer_bt_restart
                    }","viewer_bt_continue":"${this.Viewer.viewer_bt_continue
                    }","viewer_back_color":"${this.Viewer.viewer_back_color
                    }","viewer_color_text":"${this.Viewer.viewer_color_text
                    }"}`,
                  })
                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumb`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl
                    }","tumb_start":"${this.thumb.tumb_start
                    }","tumb_pausa":"${this.thumb.tumb_pause
                    }","tumb_end":"${this.thumb.tumb_end
                    }","tumb_ativo":"${this.thumb.tumb_ativo
                    }","tumb_key_name_end":"${this.thumb.tumb_key_name

                    }}`,
                  })

                  fetch(`${this.VUE_APP_HOST_API_BACKEND}/analytic`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: `{"id_vsl":"${this.IdVsl}"}`,
                  })
                    .then(response => {
                      console.log(response, 'AutoPLay')
                    })
                }
                this.close()
                this.clearFolder()
                // Não limpa currentUploadType aqui pois pode haver mais uploads
              })

              .catch(err => console.error(err))
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
      await new GetFrameVideoUrl().execute(this.frameCurrentVsl)
        .then(async resp => {
          console.log('resp', resp)

          await this.$api.put('/updateFrame', {
            id_vsl: this.frameCurrentVsl.vsl_id,
            vsl_frame: resp.file_url_frame,
          })
            .finally(() => {
              this.listarVideos()
            })
        })
    },
    async MidiaConvert(params) {
      const uploadVideoService = new UploadVideoService()
      await uploadVideoService.mediaConvert(params)
        .then(response => {
          this.MonitorarConversao(response.JobId)
        })
        .catch(err => console.error(err))
    },

    async MonitorarConversao(jobId) {
      let status = ''
      const menssageCard = `<div class="container">
    <strong>Processando <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <span class="visually-hidden">Loading...</span> </strong>
  </div>`
      const uploadVideoService = new UploadVideoService()

      this.notificationStatus = this.$notify({
        title: 'Em instantes o Embed estará disponível',
        dangerouslyUseHTMLString: true,
        message: menssageCard,
        position: 'bottom-right',
        duration: 0,
      })

      while (status !== 'COMPLETE' && status !== 'ERROR') {
        await new Promise(resolve => setTimeout(resolve, 5000)) // espera 5 segundos

        const response = await uploadVideoService.monitorarConversao(jobId)
        status = response.status

        console.log(`Status da job ${status}`)
      }
      if (status === 'COMPLETE') {
        this.$notify({
          title: 'Sucesso',
          message: 'Configurações geradas com sucesso',
          type: 'success',
          position: 'bottom-right',
          duration: 5000,
        })
      } else if (status === 'ERROR') {
        this.$notify({
          title: 'Erro',
          message: 'Ocorreu um erro durante a criação das configurações',
          type: 'error',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      setTimeout(() => {
        this.closeStatusConversao()
      }, 3000)
    },
  },
  watch: {
    uploadPercentage(newValue) {
      this.notification.message = `<div class="container">
 <strong>Fazendo upload <i>${newValue}%</i> </strong>
  <div class="progress">
    <div class="progress-bar" style="width:${newValue}%">${newValue}%</div>
  </div>
</div>`
    },
  },
}
</script>

<style scoped>
.upload-options {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.upload-option-card {
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  background: #fff;
}

.upload-option-card:hover {
  border-color: #409EFF;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.upload-icon {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}

.upload-option-card h3 {
  margin: 10px 0;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.upload-option-card p {
  color: #606266;
  margin: 10px 0 20px 0;
  font-size: 14px;
  line-height: 1.4;
}

.upload-option-card .el-button {
  width: 100%;
}

.upload-option-card.selected {
  border-color: #67C23A;
  background-color: #f0f9ff;
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
}

.selected-file {
  margin: 10px 0;
  padding: 8px;
  background-color: #f0f9ff;
  border: 1px solid #67C23A;
  border-radius: 6px;
  font-size: 12px;
  color: #67C23A;
  font-weight: 500;
  text-align: center;
  word-break: break-all;
}

.selected-file i {
  margin-right: 5px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-content h2 {
  margin: 0 0 20px 0;
  text-align: center;
  color: #303133;
}

.modal-footer {
  margin-top: 20px;
  text-align: right;
  border-top: 1px solid #e4e7ed;
  padding-top: 15px;
}

.modal-footer .el-button {
  margin-left: 10px;
}

@media (max-width: 768px) {
  .upload-options {
    flex-direction: column;
    gap: 15px;
  }
  
  .upload-option-card {
    min-width: 100%;
  }
}
</style>
